import { formatWithCommas } from "common/utils"
import React, { useEffect, useState } from "react"
import { Pie } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"

const SalesBySLA = ({ estoreDashboardData, getTotal, pieOptions }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [pieData, setPieData] = useState({ labels: [], datasets: [] })

  useEffect(() => {
    if (estoreDashboardData?.salesBySLA?.length) {
      const labels =
        estoreDashboardData?.salesBySLA?.map(item => t(item.category)) || []
      const counts =
        estoreDashboardData?.salesBySLA?.map(item => item.totalOrders) || []

      // Pie chart data
      const data = {
        labels,
        datasets: [
          {
            label: t("Total Orders"),
            data: counts,
            backgroundColor: [
              "#008FFB", // 1-3 days
              "#00E396", // 4-5 days
              "#FEB019", // 6-7 days
              "#FF4560", // 7+ days
            ],
            borderColor: "#fff",
            borderWidth: 2,
            counts,
          },
        ],
      }
      setPieData(data)
    }
  }, [estoreDashboardData, language])

  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle>{t("E-Store Order Summary By SLA")}</CardTitle>
              {estoreDashboardData?.salesBySLA?.length === 0 ? (
                <p className="text-center my-3">{t("No data found")}</p>
              ) : (
                <Table hover>
                  <thead className="table-light">
                    <tr>
                      <th>{t("Category")}</th>
                      <th>{t("Orders")}</th>
                      <th>{t("SLA %")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estoreDashboardData?.salesBySLA?.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{t(item?.category)}</td>
                          <td>{formatWithCommas(item?.totalOrders)}</td>
                          <td>
                            {formatWithCommas(
                              item?.orderPercentage?.toFixed(2)
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                  <tfoot className="table-light">
                    <tr>
                      <th>{t("Total")}</th>

                      <th>
                        {formatWithCommas(
                          getTotal(
                            estoreDashboardData?.salesBySLA,
                            "totalOrders"
                          )
                        )}
                      </th>
                      <th>
                        {formatWithCommas(
                          getTotal(
                            estoreDashboardData?.salesBySLA,
                            "orderPercentage"
                          )?.toFixed(2)
                        )}
                      </th>
                    </tr>
                  </tfoot>
                </Table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {estoreDashboardData?.slaTotals?.totalOrders ? (
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle>{t("Orders By SLA")}</CardTitle>
                <div
                  className="d-flex w-full justify-content-center align-items-center"
                  style={{ height: "500px" }}
                >
                  <Pie data={pieData} options={pieOptions} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  )
}

export default SalesBySLA
